import { Box, IconButton, Typography } from "@mui/material";
import { OpenInNewRounded } from "@mui/icons-material";

const ExternalLinkAnchor = ({
  url,
  dataTestid,
  label,
}: {
  url: string;
  dataTestid: string;
  label?: string;
}) => {
  return (
    <a
      data-testid={dataTestid}
      href={url}
      target="_blank"
      rel="noopener noreferrer external"
    >
      <Box display="flex" flexDirection="row" alignContent="space-around">
        <IconButton
          onClick={(event) => event.stopPropagation()}
          sx={{ paddingLeft: 0 }}
        >
          <OpenInNewRounded />
        </IconButton>
        {label && (
          <Typography
            display="flex"
            flexDirection="column"
            alignSelf="center"
            variant="button"
          >
            {label}
          </Typography>
        )}
      </Box>
    </a>
  );
};

export default ExternalLinkAnchor;
